import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Button from 'src/common/components/ButtonDS22';
import ButtonGroup from 'src/common/components/ButtonGroup';
import Modal from 'src/common/components/Modal';
import { PATHS } from 'src/common/constants';
import { useUserContext } from 'src/common/providers/UserProvider';
import styles from 'src/admin/common/styles/BaseModal.module.scss';

type Props = {
  open: boolean;
  closeModal: () => void;
  hasValidPayoutCurrency: boolean;
};
const NoPayoutModal: FC<Props> = ({ open, closeModal, hasValidPayoutCurrency }) => {
  const [t] = useTranslation('admin-common');
  const { userRole } = useUserContext();
  const i18nextUserRoleContext = {
    context: userRole,
  };

  return (
    <Modal
      modalOpen={open}
      closeModal={closeModal}
      label={!hasValidPayoutCurrency
        ? t('landing-page--update-payout-currency-title')
        : t('landing-page--add-payout-title')}
      className={styles.root}
    >
      <Modal.Header>
        <Modal.Title>
          {!hasValidPayoutCurrency ? t('landing-page--update-payout-currency-title') : t('landing-page--add-payout-title')}
        </Modal.Title>
        <Modal.Description>
          {!hasValidPayoutCurrency
            ? t('landing-page--update-payout-currency-description', i18nextUserRoleContext)
            : t('landing-page--add-payout-description', i18nextUserRoleContext)}
        </Modal.Description>
      </Modal.Header>
      <Modal.Footer>
        <ButtonGroup classNameModifier="centered">
          <Button variant="secondary" onClick={closeModal}>{t('landing-page--add-payout-later')}</Button>
          <Button type="link" href={PATHS.ADMIN_PAYMENTS}>
            {!hasValidPayoutCurrency ? t('landing-page--update-payout-currency-link') : t('landing-page--add-payout-link')}
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};
export default NoPayoutModal;
